var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Prop } from 'vue-property-decorator';
import { removeHttp } from '../../../common/utils';
import { IHistoryState } from '../../store/HistoryState';
import Icon from '../components/Icon';
import { toDtPosterParams, toDtButtonParams, DtModuleId, DtEid } from '../../../common/reporter';
import { Component, VueType } from '../core';
const svgmap = {
    1: 'pc',
    2: 'pc',
    3: 'phone',
    4: 'pad',
    5: 'phone',
    8: 'tv',
};
let HistoryItem = class HistoryItem extends VueType {
    get timeDur() {
        let time = Number(this.itemData.record.videoTime);
        if (time < 0) {
            time = 0;
        }
        return Number((Number(time / this.itemData.duration).toFixed(2) * 100).toFixed(0));
    }
    get timeDurStr() {
        if (this.itemData.timeDur > 99) {
            return '已看完';
        }
        if (this.itemData.timeDur <= 0) {
            return '观看不足1%';
        }
        return `观看至${this.itemData.timeDur}%`;
    }
    get itemData() {
        return this.state.getItem(this.id);
    }
    get pic() {
        return this.itemData.poster.imageUrl;
    }
    get title() {
        return this.itemData.poster.title;
    }
    get isShow() {
        return true;
    }
    get canPlay() {
        var _a;
        return !((_a = this.itemData.poster) === null || _a === void 0 ? void 0 : _a.notPlayAble);
    }
    get url() {
        const { itemData } = this;
        if (!itemData)
            return '';
        const rec = itemData.record;
        if (!this.canPlay)
            return 'javascript:void(0)';
        if (rec.vid && rec.cid) {
            return `//v.qq.com/x/cover/${rec.cid}/${rec.vid}.html`;
        }
        if (rec.vid) {
            return `//v.qq.com/x/page/${rec.vid}.html`;
        }
        if (rec.pid) {
            return `//v.qq.com/live/p/newtopic/${rec.pid}/index.html`;
        }
    }
    get aLinkTarget() {
        return this.canPlay ? '_blank' : '';
    }
    /**
       * 观看来源：1 pc; 2 web; 3 aphone; 4 ipad; 5 iphone; 8 tv
       */
    get svgid() {
        const type = this.itemData.record.playFrom;
        return `#svg_view_${svgmap[type] || 'pc'}`;
    }
    get dtPosterParams() {
        return toDtPosterParams({
            mod_id: DtModuleId.HISTORY,
            mod_idx: 0,
            tab_title: this.tabTitle,
            tab_idx: this.tabIdx,
            item_idx: this.index,
            vid: this.itemData.record.vid,
            cid: this.itemData.record.cid,
            lid: this.itemData.record.lid,
            is_hover: 0,
        });
    }
    get dtButtonParams() {
        return toDtButtonParams({
            title: 'delete_poster',
        });
    }
    render() {
        const { itemData } = this;
        if (!itemData)
            return null;
        return (<div class="history_item item_size" v-show={this.isShow} v-wind dt-eid={DtEid.POSTER} dt-params={this.dtPosterParams}>
                  <a href={this.url} class="history_item_top del_par" target={this.aLinkTarget} dt-source-el={this.dtPosterParams}>
                    <img class="history_item_pic" v-src={removeHttp(this.pic)}></img>
                    {this.itemData.epUpdate && <span class="history_item_update">{this.itemData.epUpdate}</span>}
                    {this.canPlay &&
            <div class="hover_mask">
                        <div class="hover_mask_play"></div>
                        <svg class="del_x" data-del={itemData.record.recordId} dt-eid={DtEid.BUTTON} dt-params={this.dtButtonParams} dt-source-ignore>
                            <use xlinkHref="#svg_clear_item"></use>
                        </svg>
                      </div>}
                    {!this.canPlay &&
            <div class="history_item_play_mask">
                        <strong>已下架</strong>
                        <p>暂不可观看</p>
                      </div>}
                  </a>
                <strong class="history_item_title nowrap_two">
                    <a href={this.url} title={this.title} target={this.aLinkTarget} dt-source-el={this.dtPosterParams}>
                        {this.title}
                    </a>
                </strong>
                {!Number.isNaN(this.timeDur) && <p class="history_item_time nowrap">
                    <Icon w={16} h={16} xlink={this.svgid}></Icon>
                    <span>{this.timeDurStr}</span>
                </p>}
            </div>);
    }
};
__decorate([
    Prop()
], HistoryItem.prototype, "id", void 0);
__decorate([
    Prop()
], HistoryItem.prototype, "tabTitle", void 0);
__decorate([
    Prop()
], HistoryItem.prototype, "tabIdx", void 0);
__decorate([
    Prop()
], HistoryItem.prototype, "index", void 0);
__decorate([
    IHistoryState
], HistoryItem.prototype, "state", void 0);
HistoryItem = __decorate([
    Component
], HistoryItem);
export default HistoryItem;
